<template>
  <div class="toExaminePersonnel">
    <el-form ref="ruleForm" :model="ruleForm" label-width="80px">
      <div class="title">
        <div class="titleChild">
          <el-form-item label="当前状态">
            <el-input v-model="ruleForm.currentState"></el-input>
          </el-form-item>
        </div>
        <div class="seasions">
          <el-form-item label="申请原因">
            <el-input v-model="ruleForm.currentState"></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="people">
        <div class="picture">
          <img :src="peoplePhoto" />
        </div>
        <div class="peopleInformation">
          <el-row>
            <el-col :span="24">
              <div style="float: left">
                <el-form-item label="编号">
                  <el-input v-model="ruleForm.Number" placeholder="默认"></el-input>
                </el-form-item>
              </div>
              <el-form-item label="性别">
                <el-select v-model="ruleForm.sex" filterable>
                  <el-option label="男" value="1"></el-option>
                  <el-option label="女" value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div style="float: left">
                <el-form-item label="姓名">
                  <el-input v-model="ruleForm.name" placeholder="默认"></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="tab">
        <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
          <el-tab-pane label="公司信息" name="first">
            <div class="tabArea">
              <div style="margin-top: 10px" v-for="(item, index) in companyList" :key="index">
                <el-row>
                  <el-col :span="24">
                    <div class="companytitle">公司信息{{ index + 1 }}</div>
                  </el-col>
                </el-row>
                <el-row class="left">
                  <el-col :span="24">
                    <el-form-item label="公司" label-width="120px">
                      <el-input v-model="item.companyName"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="部门" label-width="120px">
                      <el-input v-model="item.companyClass"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <div style="margin-top: 10px">
                <el-row>
                  <el-col :span="24">
                    <div class="companytitle">联系方式</div>
                  </el-col>
                </el-row>
                <el-row class="callWays">
                  <el-col :span="24">
                    <div style="float: left">
                      <el-form-item label="移动电话" label-width="120px">
                        <el-input v-model="callways.phone"></el-input>
                      </el-form-item>
                    </div>
                    <div style="float: left">
                      <el-form-item label="电子邮箱" label-width="120px">
                        <el-input v-model="callways.email"></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="个人信息(仅限用 户本人和管理员)" name="second">
            <div class="tabArea">
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="selfInformation">
                    <el-form-item label="国籍" label-width="120px">
                      <el-input v-model="selfList.nationality"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="selfInformation">
                    <el-form-item label="身份证号" label-width="120px">
                      <el-input v-model="selfList.idCard"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="selfInformation">
                    <el-form-item label="护照号" label-width="120px">
                      <el-input v-model="selfList.passportNo"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div></div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <div class="companytitle top">联系方式</div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="selfInformation">
                    <el-form-item label="银行账号" label-width="120px">
                      <el-input v-model="selfList.bankAccount"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="selfInformation">
                    <el-form-item label="开户行" label-width="120px">
                      <el-input v-model="selfList.openingBank"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="selfInformation">
                    <el-form-item label="开户名" label-width="120px">
                      <el-input v-model="selfList.openingName"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="selfInformation">
                    <el-form-item label="银行预留电话" label-width="120px">
                      <el-input v-model="selfList.bankReservedPhone"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <div class="grid-content bg-purple">
                    <el-form-item label="身份证正面" label-width="120px">
                      <div class="idCard">
                        <img :src="selfList.frontOfIdCard" />
                      </div>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content bg-purple-light">
                    <el-form-item label="身份证反面" label-width="120px">
                      <div class="idCard">
                        <img :src="selfList.ReverseOfIdCard" />
                      </div>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
          <el-tab-pane label="系统映射表" name="third">
            <div class="tabArea">
              <sirui-table ref="siruiTable" :loading="load" :data="tableData" :paging="false">
                <vxe-table-column
                  v-for="(item, index) in columnList"
                  :key="index"
                  :width="item.width"
                  :field="item.prop"
                  :title="item.label"
                ></vxe-table-column>
              </sirui-table>
            </div>
          </el-tab-pane>
          <el-tab-pane label="历史记录" name="fourth">
            <div class="tabArea">
              <sirui-table ref="siruiTable" :loading="load" :data="tableData" :paging="false">
                <vxe-table-column
                  v-for="(item, index) in columnList"
                  :key="index"
                  :width="item.width"
                  :field="item.prop"
                  :title="item.label"
                ></vxe-table-column>
              </sirui-table>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="button">
        <div class="buttonList">
          <el-button type="primary" class="buttonStyle" icon="el-icon-edit" style="#6299FE"
            >返回</el-button
          >
          <el-button type="primary" class="buttonStyle" icon="el-icon-edit" style="#6299FE"
            >驳回</el-button
          >
          <el-button type="primary" class="buttonStyle" icon="el-icon-edit" style="#6299FE"
            >推送以获取映射关系</el-button
          >
          <el-button type="primary" class="buttonStyle" icon="el-icon-edit" style="#6299FE"
            >通过</el-button
          >
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
  import SiruiTable from '@/components/SiruiTable';
  export default {
    components: {
      SiruiTable,
    },
    computed: {
      columnList() {
        return [
          {
            prop: 'partnerCode',
            label: this.$t('personnel.table.cooperationType'),
            width: 120,
          },
          { prop: 'Name', label: this.$t('personnel.table.Name'), width: 120 },
          { prop: 'company', label: this.$t('personnel.table.company'), width: 190 },
          {
            prop: 'department',
            label: this.$t('personnel.table.department'),
            width: 210,
          },
          { prop: 'phone', label: this.$t('personnel.table.phone'), width: 180 },
          { prop: 'email', label: this.$t('personnel.table.email'), width: 180 },
          { prop: 'dataState', label: this.$t('personnel.table.dataState'), width: 180 },
          {
            prop: 'creatTime',
            label: this.$t('personnel.table.creatTime'),
            width: 120,
          },
        ];
      },
    },
    data() {
      return {
        load: false,
        tableData: [],
        peoplePhoto: require('../../../assets/login-bg.jpg'),
        ruleForm: {
          currentState: '',
          Number: '', //编号
          name: '', //姓名
          sex: '1', //性别
        },
        activeName: 'first',
        companyList: [
          { companyName: '芮想', companyClass: '前端' },
          { companyName: '芮想2', companyClass: '前端2' },
        ],
        callways: {
          pthone: '',
          email: '',
        }, //公司联系方式
        selfList: {
          nationality: '', //国籍
          idCard: '', //身份证号
          passportNo: '', //护照号
          bankAccount: '', //银行账号
          openingBank: '', //开户行
          openingName: '', //开户名
          bankReservedPhone: '', //银行预留电话
          frontOfIdCard: require('../../../assets/login-bg.jpg'),
          ReverseOfIdCard: require('../../../assets/login-bg.jpg'),
        }, //个人信息
      };
    },
    mounted() {
      this.tableData = [
        {
          partnerCode: '1000035862',
          Name: '张大伟',
          company: '绍兴海富新材料有限公司',
          department: '供应商兼客户',
          phone: '1868686688',
          email: '88885555@qq.com',
          dataState: '数据状态数据状态数据状态',
          creatTime: '2019-08-10',
        },
        {
          partnerCode: '1000035862',
          Name: '张大伟',
          company: '绍兴海富新材料有限公司',
          department: '供应商兼客户',
          phone: '1868686688',
          email: '88885555@qq.com',
          dataState: '数据状态数据状态数据状态',
          creatTime: '2019-08-10',
        },
      ];
    },
    methods: {
      handleClick() {},
    },
  };
</script>
<style scoped>
  .toExaminePersonnel {
    font-size: 12px;
  }
  .toExaminePersonnel .title {
    height: 96px;
    background-color: #fff;
  }
  .toExaminePersonnel .titleChild {
    height: 32px;
    width: 200px;
    padding-top: 10px;
    padding-left: 30px;
  }
  .toExaminePersonnel .seasions {
    height: 32px;
    /* width: 200px; */
    padding-top: 10px;
    padding-right: 30px;
    padding-left: 30px;
  }
  .toExaminePersonnel .people {
    height: 131px;
    background-color: #fff;
    margin-top: 10px;
    box-sizing: border-box;
    padding-top: 26px;
    padding-left: 30px;
  }
  .toExaminePersonnel .people .el-input--small {
    width: 142px;
  }
  .toExaminePersonnel .selfInformation .el-input--small {
    width: 142px;
  }
  .toExaminePersonnel .top {
    margin: 10px 0;
  }
  .toExaminePersonnel .callWays .el-input--small {
    width: 142px;
  }
  .toExaminePersonnel .people .el-select {
    width: 142px;
  }
  .toExaminePersonnel .people .el-form-item--mini.el-form-item,
  .el-form-item--small.el-form-item {
    margin-bottom: 8px !important;
  }
  .toExaminePersonnel .picture {
    width: 60px;
    height: 79px;
    float: left;
  }
  .toExaminePersonnel .picture > img {
    width: 100%;
    height: 100%;
  }
  .toExaminePersonnel .peopleInformation {
    height: 79px;
    width: 800px;
    float: left;
    margin-left: 10px;
    /* background: blue; */
  }
  .toExaminePersonnel .tab {
    margin-top: 10px;
    background-color: #fff;
  }
  .toExaminePersonnel .tabArea {
    box-sizing: border-box;
    padding: 20px;
    padding-top: 0px;
  }
  .toExaminePersonnel .tabArea .el-tabs__content {
    overflow: hidden;
    padding: 10px;
    position: relative;
  }
  .toExaminePersonnel .tab .el-tabs__nav-scroll {
    background: #f3f6fa;
  }
  .toExaminePersonnel .companytitle {
    margin-bottom: 10px;
  }
  .toExaminePersonnel .button {
    height: 78px;
    background-color: #fff;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .toExaminePersonnel .buttonList {
    height: 32px;
    margin: auto;
    width: fit-content;
    padding-top: 23px;
  }
  .toExaminePersonnel .buttonStyle {
    border: none;
    min-width: 102px;
    height: 32px;
  }
  .toExaminePersonnel .idCard {
    width: 347px;
    height: 173px;
    margin-top: 10px;
  }
  .toExaminePersonnel .idCard > img {
    width: 100%;
    height: 100%;
  }
</style>
